import { motion } from "framer-motion";

const row1 = [
    { url: "https://images.unsplash.com/photo-1617788138017-80ad40651399?w=1200", label: "EV & Battery Gigafactory" },
    { url: "https://images.pexels.com/photos/18471441/pexels-photo-18471441.jpeg?w=1200", label: "Semiconductor Facility" },
    { url: "https://images.unsplash.com/photo-1680992046626-418f7e910589?w=1200", label: "Data Centers" },
    { url: "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=1200", label: "Hospitals & Medical Towers" },
    { url: "https://customer-assets.emergentagent.com/job_pes-modern/artifacts/fkw5y69l_IMG_0018.jpeg", label: "Cleanroom Design" },
    { url: "https://images.pexels.com/photos/32831921/pexels-photo-32831921.jpeg?w=1200", label: "Urban Highrise" },
];

const row2 = [
    { url: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1200", label: "Distribution Warehouse / Fulfillment Center" },
    { url: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1600", label: "Corporate Campus" },
    { url: "https://images.unsplash.com/photo-1562774053-701939374585?w=1200", label: "University Research" },
    { url: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1200", label: "K-12 Science Academy" },
    { url: "https://customer-assets.emergentagent.com/job_pes-modern/artifacts/d2h53jte_IMG_0017.webp", label: "Pharmaceutical Plant" },
    { url: "https://customer-assets.emergentagent.com/job_pes-modern/artifacts/erdl1ag9_IMG_0013.jpeg", label: "Luxury Retail Plaza" },
];

function Marquee({ items, reverse = false, speed = 40 }) {
    return (
        <div className="overflow-hidden py-3" data-testid={`marquee-${reverse ? "reverse" : "forward"}`}>
            <motion.div
                className="flex gap-5 min-w-max"
                animate={{ x: reverse ? ["-50%", "0%"] : ["0%", "-50%"] }}
                transition={{ duration: speed, repeat: Infinity, ease: "linear" }}
            >
                {[...items, ...items].map((it, i) => (
                    <div
                        key={i}
                        className="relative w-[360px] h-[240px] rounded-2xl overflow-hidden border border-white/5 hover:border-blue-500/30 transition-colors group flex-shrink-0"
                    >
                        <img src={it.url} alt={it.label} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/30 to-transparent" />
                        <div className="absolute bottom-4 left-5 right-5">
                            <div className="inline-flex items-center px-3 py-1 rounded-full bg-slate-900/70 backdrop-blur-md border border-white/10 text-xs text-cyan-200">
                                {it.label}
                            </div>
                        </div>
                    </div>
                ))}
            </motion.div>
        </div>
    );
}

export default function VisualMarquee() {
    return (
        <section className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden" data-testid="visual-marquee">
            <div className="max-w-7xl mx-auto px-6 md:px-10 mb-14">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 max-w-6xl">
                    <div>
                        <div className="inline-flex items-center gap-2 text-xs font-mono tracking-[0.2em] uppercase text-cyan-400 mb-6">
                            <span className="w-8 h-px bg-cyan-400/60" /> On the Drawing Board
                        </div>
                        <h2 className="font-heading font-black text-white text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tighter">
                            Every sector. Every scale.
                        </h2>
                    </div>
                    <p className="text-base md:text-lg text-slate-400 leading-relaxed max-w-md">
                        A glimpse of the environments we engineer — from cleanrooms and battery gigafactories
                        to hospital suites and urban towers.
                    </p>
                </div>
            </div>
            <div className="relative -mx-6 md:-mx-0">
                <div className="absolute left-0 top-0 bottom-0 w-20 md:w-40 bg-gradient-to-r from-slate-900 to-transparent z-10 pointer-events-none" />
                <div className="absolute right-0 top-0 bottom-0 w-20 md:w-40 bg-gradient-to-l from-slate-900 to-transparent z-10 pointer-events-none" />
                <Marquee items={row1} speed={60} />
                <Marquee items={row2} reverse speed={50} />
            </div>
        </section>
    );
}
